import React from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import IconButton from '@mui/material/IconButton'

const HMapContainerArrow = ({ toggle, setToggle, className, disabled }) => {
  const toggleHandler = () => {
    setToggle(!toggle)
  }

  const iconButtonProps = {
    'aria-label': 'expand row',
    size: 'small',
    ...(className && { className }),
    ...(!disabled && setToggle && { onClick: toggleHandler })
  }

  return (
    <IconButton {...iconButtonProps}>
      <KeyboardArrowDownIcon
        sx={(theme) => ({
          color: theme.palette.primary.accent,
          transform: !disabled && toggle ? 'rotate(-180deg)' : 'none',
          transition: 'transform .25s'
        })}
      />
    </IconButton>
  )
}

export default React.memo(HMapContainerArrow)
